angular.module('date-formater', [])
    .service('DateFormater', DateFormater);

DateFormater.$inject = [];

function DateFormater() {

    var dateFormater = {
        data:{},
        fields:{},
        takeDate: function () {
            dateFormater.fields.forEach(function(field) {
                if (field.type === 'PERIOD' || field.type === 'DATE') {
                    field.value = new Date(field.value);
                }
            });
        },
        returnOriginDate: function() {
            dateFormater.fields.forEach(function(field) {
                if (field.type === 'PERIOD' || field.type === 'DATE') {
                    field.value = new Date(dateFormater.data.originDate);//todo scope
                }
            });
        }
    };

    return dateFormater;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/dateFormater/date-formater.js
 ** module id = 103
 ** module chunks = 1
 **/